import { merge } from 'lodash'
import contentSettings from '~/sites/shop/content.settings'

const overloadSettings = {
  cookieBot: {
    cbid: '3a0750e9-b020-418d-b273-fc9e48d8d035',
  },
  events: {
    heureka: {
      conversions: {
        enable: false,
      },
      directConversions: {
        enable: true,
        apiKey: '8bb9c7870dd26abb8df546afeac922f46b0b',
        allowedSites: ['cvb'],
        portal: 'cz',
        itemIdSource: 'shoppable.marketingCode',
        includeAdditionalItems: true,
      },
      shopPurchase: {
        enable: true,
      },
    },
    quarticon: {
      enable: true,
    },
  },
  functions: {
    compare: true,
    ssrPropertyPicker: true,
    minimalPricePeriod: true,
  },
}

export default merge(contentSettings, overloadSettings)
